import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {
  PRACTICE_STATUS_OPZIONATO,
  PRACTICE_STATUS_CONFERMATO,
  PRACTICE_STATUS_IN_LAVORAZIONE,
  PRACTICE_STATUS_PREVENTIVATO,
  PRACTICE_STATUS_ANNULLATO,
  PRACTICE_STATUS_CONCLUSO,
  PRACTICE_STATUS_STAND_BY,
  PRACTICE_TYPE_PRIVATO,
  PRACTICE_TYPE_INPS,
  PRACTICE_TYPE_ALTRO,
  PRACTICE_TYPE_AZIENDA_CONVENZIONATA,
  PRACTICE_TYPE_WELFARE,
  PRACTICE_TYPE_INPSNUOVO,
} from '../utils/constants';

// Mapping legacy mantenuto
export const PRACTICE_TYPES = {
  1: PRACTICE_TYPE_PRIVATO,
  2: PRACTICE_TYPE_INPS,
  3: PRACTICE_TYPE_ALTRO,
  4: PRACTICE_TYPE_AZIENDA_CONVENZIONATA,
  5: PRACTICE_TYPE_WELFARE,
  6: PRACTICE_TYPE_INPSNUOVO,
};

export const EXTRA_LABELS_BY_PRACTICE_TYPE = {
  1: 'PVT',
  2: 'INPS',
  3: '',
  4: 'AZ',
  5: '',
  6: 'INPSN',
};

// Rebranding 2026 · classi badge per readableStatus
const STATUS_BADGE_CLASS = {
  [PRACTICE_STATUS_OPZIONATO]:       'gc-sc-badge--opzionato',
  [PRACTICE_STATUS_CONFERMATO]:      'gc-sc-badge--confermato',
  [PRACTICE_STATUS_IN_LAVORAZIONE]:  'gc-sc-badge--lavorazione',
  [PRACTICE_STATUS_PREVENTIVATO]:    'gc-sc-badge--standby',
  [PRACTICE_STATUS_ANNULLATO]:       'gc-sc-badge--annullato',
  [PRACTICE_STATUS_CONCLUSO]:        'gc-sc-badge--annullato',
  [PRACTICE_STATUS_STAND_BY]:        'gc-sc-badge--standby',
};

// Border-left accent color in base allo status
const STATUS_LACCENT_CLASS = {
  [PRACTICE_STATUS_OPZIONATO]:       'gc-laccent--warning',
  [PRACTICE_STATUS_CONFERMATO]:      'gc-laccent--success',
  [PRACTICE_STATUS_IN_LAVORAZIONE]:  'gc-laccent--petrolio',
  [PRACTICE_STATUS_PREVENTIVATO]:    'gc-laccent--diamond',
  [PRACTICE_STATUS_ANNULLATO]:       'gc-laccent--diamond',
  [PRACTICE_STATUS_CONCLUSO]:        'gc-laccent--diamond',
  [PRACTICE_STATUS_STAND_BY]:        'gc-laccent--diamond',
};

const mapPracticeType = (type) => PRACTICE_TYPES[type] || '';

// Rebranding 2026 · PracticeItem → gc-sc-practice (accordion ivory)
// State interno per open/close, sistema riusabile (Payments, Documents)
const PracticeItem = ({practice, children, defaultOpen = false}) => {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = `gc-practice-panel-${practice.shortCode || practice.code}`;
  const badgeClass = STATUS_BADGE_CLASS[practice.readableStatus] || 'gc-sc-badge--standby';
  const laccentClass = STATUS_LACCENT_CLASS[practice.readableStatus] || 'gc-laccent--diamond';
  const classes = [
    'gc-sc-practice',
    open ? 'gc-sc-practice--open' : '',
    'gc-laccent',
    laccentClass,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <button
        type="button"
        className="gc-sc-practice__summary"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(prev => !prev)}
      >
        <div className="gc-sc-practice__cell">
          <span className="gc-sc-practice__code">{practice.shortCode}</span>
        </div>
        <div className="gc-sc-practice__cell">
          <span className="gc-sc-badge gc-sc-badge--division">{practice.practiceDivision}</span>
          <span className={`gc-sc-badge ${badgeClass}`}>{practice.readableStatus.toUpperCase()}</span>
          <span className="gc-sc-practice__type">{mapPracticeType(practice.practiceType)}</span>
        </div>
        <div className="gc-sc-practice__cell">{practice.packageTitle}</div>
        <div className="gc-sc-practice__cell">{practice.destination}</div>
        <div className="gc-sc-practice__cell gc-sc-practice__chevron" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </div>
      </button>

      {open && (
        <div id={panelId} className="gc-sc-practice__details">
          {children}
        </div>
      )}
    </div>
  );
};

PracticeItem.propTypes = {
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  practice: PropTypes.shape({
    code: PropTypes.string,
    shortCode: PropTypes.string,
    practiceDivision: PropTypes.string,
    readableStatus: PropTypes.string,
    practiceType: PropTypes.number,
    packageTitle: PropTypes.string,
    destination: PropTypes.string,
  }),
};

export default PracticeItem;
